<header class="dod-head">
  <div class="dod-title">
    <span class="dod-title-icon" aria-hidden="true">
      <mat-icon>dashboard_customize</mat-icon>
    </span>
    <div class="dod-title-text">
      <h2 mat-dialog-title>Design templates</h2>
      <p>{{ total() }} saved template{{ total() === 1 ? '' : 's' }}</p>
    </div>
  </div>

  <div class="dod-search">
    <mat-icon aria-hidden="true">search</mat-icon>
    <input
      type="text"
      placeholder="Search templates"
      [ngModel]="search()"
      (ngModelChange)="search.set($event)"
      aria-label="Search templates"
    />
  </div>

  <button type="button" class="dod-icon" (click)="refresh()" matTooltip="Reload templates" aria-label="Reload templates">
    <mat-icon>refresh</mat-icon>
  </button>
  <button type="button" class="dod-icon" mat-dialog-close matTooltip="Close" aria-label="Close">
    <mat-icon>close</mat-icon>
  </button>
</header>

<div mat-dialog-content class="dod-body">
  <p class="dod-status" role="status" *ngIf="data.loading">Loading templates…</p>

  <div class="dod-error" role="alert" *ngIf="data.error">
    <p>{{ data.error }}</p>
    <button type="button" class="dod-retry" (click)="refresh()">Retry</button>
  </div>

  <div class="dod-empty" *ngIf="!data.loading && !data.error && !total()">
    <mat-icon aria-hidden="true">{{ search() ? 'search_off' : 'dashboard_customize' }}</mat-icon>
    <p>{{ search() ? 'No templates match that search.' : 'No templates saved yet.' }}</p>
    <small *ngIf="!search()">Save a design and it will appear here.</small>
  </div>

  <section class="dod-group" *ngFor="let group of groups(); trackBy: trackGroup">
    <button
      type="button"
      class="dod-group-head"
      [attr.aria-expanded]="!isCollapsed(group.key)"
      (click)="toggleGroup(group.key)"
    >
      <mat-icon>{{ isCollapsed(group.key) ? 'chevron_right' : 'expand_more' }}</mat-icon>
      <mat-icon class="dod-group-icon">{{ group.key ? 'folder' : 'folder_off' }}</mat-icon>
      <span class="dod-group-name">{{ group.name }}</span>
      <span class="dod-group-count">{{ group.templates.length }}</span>
    </button>

    <div class="dod-grid" *ngIf="!isCollapsed(group.key)">
      <button
        type="button"
        class="dod-card"
        *ngFor="let template of group.templates; trackBy: trackTemplate"
        [class.is-active]="data.activeId === template['id']"
        (click)="open(template)"
      >
        <!-- A live mini-render when the template parses, else a baked image. -->
        <span class="dod-thumb" *ngIf="data.previewScreen(template) as screen; else staticThumb" aria-hidden="true">
          <app-design-screen-preview [screen]="screen"></app-design-screen-preview>
        </span>
        <ng-template #staticThumb>
          <img class="dod-thumb" [src]="data.thumbnail(template)" [alt]="name(template) + ' preview'" />
        </ng-template>

        <span class="dod-badge" *ngIf="data.activeId === template['id']">
          <mat-icon>check_circle</mat-icon> Open
        </span>
        <span class="dod-open-hint" *ngIf="data.activeId !== template['id']">
          <mat-icon>open_in_new</mat-icon> Open
        </span>

        <span class="dod-card-label">
          <strong>{{ name(template) }}</strong>
          <small>{{ kind(template) }}</small>
        </span>
      </button>
    </div>
  </section>
</div>
